import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MobileCompanyDrawer from "./MobileCompanyDrawer";

/**
 * Drawer-only route. Used when App.jsx renders modal routes on top of a
 * backgroundLocation (so the background page remains visible).
 */
export default function MobileCompanyDrawerRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { companyID } = useParams();

  const handleClose = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
      return;
    }
    navigate("/companies");
  };

  return (
    <MobileCompanyDrawer open={true} companyID={companyID} onClose={handleClose} />
  );
}


